<template>
  <ReportWrapper
    :is-downloading="isFetching"
    :disable-download="!selectedCustomer"
    @download="downloadPdf"
  >
    <template #prepend>
      <CustomerAutocomplete
        v-model="selectedCustomer"
        class="w-2/6 x-sm:w-full"
        label=""
        placeholder="Customer"
        customer
        hide-details
        :return-object="false"
        item-value="accountNumber"
      />
    </template>
  </ReportWrapper>
</template>
<script lang="ts">
import { defineAsyncComponent, defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFile } from '@/helpers/download';

export default defineComponent({
  name: 'ReportInventory',
  components: {
    ReportWrapper: defineAsyncComponent(() => import('@/components/reports/ReportWrapper.vue')),
    CustomerAutocomplete: () =>
      import('@/components/autocomplete/CustomerAutocompleteComponent.vue'),
  },
  setup() {
    const selectedCustomer = ref<string>('');
    const { useDownloadInventoryReport } = useReports();
    const { refetch: downloadReport, isFetching } = useDownloadInventoryReport(selectedCustomer);

    const downloadPdf = async () => {
      if (isFetching.value) return;
      const { data } = await downloadReport();

      if (!data) return;

      downloadFile(data.base64Data, data.filename ?? 'Inventory Report');
    };

    return { selectedCustomer, isFetching, downloadPdf };
  },
});
</script>
